import { CustomAddress } from "../../interfaces/address.interface";
import { Subscription } from '../company/company.interface';
import { IPhonebookContact } from '../phonebook/phonebook.interface';
import { BaseModel } from "../_base/model.class";

export class Property extends BaseModel {
  constructor(
    private _id?: string,
    private admin?: {
      company: string;
      users: string[];
    },
    private code?: string,
    private owner?: string,
    private type?: string,
    private structure?: string,
    private documentArchive?: string,
    private name?: string,
    private masterCode?: string,
    private taxCode?: string,
    private address?: CustomAddress,
    private notifyMail1?: string,
    private notifyMail2?: string,
    private expirationNotifyMail1?: string,
    private expirationNotifyMail2?: string,
    private iban?: string,
    private dossier?: boolean,
    private dossierEmail?: string,
    private administrationStartDate?: string,
    private administrationEndDate?: string,
    private buildingYear?: number,
    private buildingPermitYear?: number,
    private docsStoredAtArchedi?: boolean,
    private subscription?: Subscription,
    private sharedUser?: string,
    private totalDocsInserted?: number,
    private totalDocsProgressive?: number,
    private phonebook?: IPhonebookContact[],
    private active?: boolean,
    private nfcDetails?: {
      tag: string;
      message?: string;
    },
    private totalDocsWithExpiration?: number,
    private totalDocsMissingMandatory?: number,
    private newDocumentTree?: boolean,
    private createdBy?: string,
    private createdAt?: Date,
    private updatedBy?: string,
    private updatedAt?: Date
  ) {
    super();

    this.setRequiredFields([
      "_id",
      "admin",
      "owner",
      "type",
      "name",
      "address",
      "notifyMail1",
      "docsStoredAtArchedi",
      "active",
      "nfcDetails",
      "createdBy",
      "createdAt"
    ]);
  }
}
